<template>
  <div class="box">

    <nav class="panel has-background-white">
      <p class="panel-heading has-text-weight-normal">
        最新公告
      </p>
      <a class="panel-block" v-for="(announce, index) in paginatedData(pagination.current)" id="announcements" @click="accessContent(index)" :key="'announcement-' + index">
        <b-icon pack="far" icon="comment-dots"></b-icon>&nbsp;&nbsp;&nbsp;
        <span>
          {{ $prismic.richTextAsPlain(announce.data.content).substr(0, 35) }} ... ({{ announce.first_publication_date.substr(0, 10) }})
        </span>
      </a>

      <div class="panel-block">
        <b-pagination
          :total="pagination.total"
          :current.sync="pagination.current"
          :order="'is-centered'"
          :size="'is-small'"
          :simple="true"
          :per-page="pagination.perPage">
        </b-pagination>
      </div>
    </nav>
  </div>
</template>

<script>
import PrismicDOM from 'prismic-dom';
import moment from 'moment';

export default {
  name: 'AnnouncementCard',
  data() {
    return {
      announcements: [],
      isActive: false,
      buttonWidth: 390,
      pagination: {
        total: '',
        current: 1,
        perPage: 7,
      },
    };
  },
  mounted() {
    window.onload = () => {
      this.buttonWidth = document.getElementById('announcements').offsetWidth;
    };
  },
  methods: {
    accessContent(index) {
      return this.$dialog.alert({
        title: moment(this.announcements[index].first_publication_date).format('MMM D, YYYY (ddd)'),
        message: PrismicDOM.RichText.asHtml(this.announcements[index].data.content),
      });
    },
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'announcements'),
        { orderings: '[document.first_publication_date desc]' },
      ).then((response) => {
        this.announcements = response.results;
        this.pagination.total = response.results.length;
      });
    },
    paginatedData(current) {
      return this.announcements.slice(current * 7 - 7, current * 7);
    },
  },
  created() {
    this.getContent();
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  > button:not(.is-dark) {
    justify-content: left;
  }
}

.panel-block {
  border: none;
  border-radius: 4px;
  &:last-child {
    padding: 0.5em 0 0 0.75em;
    justify-content: flex-end;
  }
}

p.panel-heading {
  border: none;
  border-radius: 4px;
  margin-bottom: 0.5em;
}
</style>
